<div class="minimized-meetings-container" *ngIf="minimizedMeetings.length > 0">
  <div class="minimized-meeting-item" *ngFor="let meeting of minimizedMeetings" 
       (click)="restoreMeeting(meeting, $event)"
       [class]="getStatusClass(meeting.status)">
    <div class="meeting-info">
      <div class="meeting-title">
        <i class="bi bi-camera-video me-2"></i>
        <span>{{ meeting.meetingTitle || 'Meeting' }}</span>
      </div>
      <div class="meeting-details">
        <span class="meeting-id">ID: {{ meeting.meetingId }}</span>
        <span class="meeting-status" [class]="getStatusClass(meeting.status)">
          {{ getStatusText(meeting.status) }}
        </span>
      </div>
    </div>
    <div class="meeting-actions">
      <button type="button" class="btn-restore" (click)="restoreMeeting(meeting, $event)" 
              title="Restore Meeting">
        <i class="bi bi-arrows-angle-expand"></i>
      </button>
      <button type="button" class="btn-close" (click)="closeMeeting(meeting.meetingId, $event)" 
              title="Close Meeting">
        <i class="bi bi-x-lg"></i>
      </button>
    </div>
  </div>
</div>

